import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AiScoringService {

  constructor(private http: ApiService) {}

  getAiScoringGuideline(data: any): Observable<any> {
    return this.http.post(environment.getAiScoringGuideline, data);
  }

  updateAiScoringGuideline(data: any): Observable<any> {
    return this.http.post(environment.updateAiScoringGuideline, data);
  }

  resetAiScoringGuideline(data: any): Observable<any> {
    return this.http.post(environment.resetAiScoringGuideline, data);
  }

  triggerLeadAiScore(data: any): Observable<any> {
    return this.http.post(environment.triggerLeadAiScore, data);
  }
}
